export default {
  playable: {
    label: 'プレイ可能なプロジェクト',
    projectInfo:
      'プロモーション製品情報（CTAリンクおよびページ読み込みに使用）',
    delete: 'プロジェクトの削除',
    startCreate: 'すぐにプレイ可能な広告の作成を開始したいですか？',
    messageDes:
      'Playturboが提供するテンプレートを使用して、最初のプレイ可能な広告のアイデアを作成してみてください！',
    describe:
      'エレメント単位のプレイ広告制作プラットフォームは、主要な広告ネットワークプラットフォームをカバーし、ワンクリックでパッケージ化または自由なダウンロードをサポートしています。',
    choice: 'テンプレートを選択',
    create: {
      name: '新しいプロジェクトを作成',
      template: 'テンプレートを選択',
      blank: 'コンテンツエディタ',
      iv: '動画をプレイアブル化',
    },
    filter: {
      projectname: 'プロジェクト名',
      projectid: 'プロジェクトID',
      projectstatus: 'プロジェクトステータス',
      edittime: '更新時間',
      createtime: '作成時間',
    },
    table: {
      project: 'プロジェクト名およびID',
      productname: '製品名',
      Status: 'プロジェクトステータス',
      demoTip:
        'このプロジェクトはデモプロジェクトで、トップに固定されています。',
      edittips: '編集',
      previewtips: 'プレビュー',
      applytips: 'Mintegralにプッシュ',
      downloadtips: 'ダウンロード',
      packChannel: 'パッケージチャネル',
      pushFolder: 'プッシュフォルダ',
      detail: '詳細を見る',
    },
    more: 'その他',
    moretemplates: 'その他のテンプレートを表示',
    editProjectConfirm: {
      title: '編集',
      desc: 'このプロジェクトはデモプロジェクトで、編集できません。',
    },
    delProjectConfirm: {
      title: '削除',
      desc: 'このプロジェクトはデモプロジェクトで、削除できません。',
    },
    detail: {
      templateName: 'テンプレート名',
      direction: '適応方向',
    },
    resetProjectLabel: 'デモプロジェクトをリセット',
    resetProjectConfirm: {
      title: 'デモプロジェクトをリセット',
      desc: 'デモプロジェクトをリセットしてもよろしいですか？',
      error: 'このデモプロジェクトはリセットの必要はありません',
      success: 'デモプロジェクトが正常にリセットされました',
      fail: 'デモプロジェクトのリセットに失敗しました',
    },
  },
}
